module.exports = __webpack_public_path__ + "img/medicine.80d44610.png";